import _jsx from "@babel/runtime/helpers/jsx";
var _span, _span2, _span3, _span4;
import React from 'react';
import PropTypes from 'prop-types';
import { DisclaimerText } from 'reaxl';
import clsx from 'clsx';
function FooterLegal(_ref) {
  let {
    className,
    onClick,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(DisclaimerText, Object.assign({
    className: clsx(className, 'text-legal text-center'),
    "data-cmp": "txt-visitorAgreement"
  }, rest), _span || (_span = /*#__PURE__*/_jsx("span", {}, void 0, "By using this service, you accept the terms of our\xA0")), /*#__PURE__*/_jsx("span", {}, void 0, /*#__PURE__*/React.createElement("a", Object.assign({
    key: "visitorAgreement",
    className: "display-inline-block padding-bottom-2",
    href: "/legal/visitor-agreement"
  }, onClick && {
    onClick: event => {
      onClick(event, {
        type: 'additional',
        text: 'Visitor Agreement'
      });
      return true;
    }
  }), "Visitor Agreement"), _span2 || (_span2 = /*#__PURE__*/_jsx("span", {}, "dot", ". "))), /*#__PURE__*/_jsx("span", {}, void 0, /*#__PURE__*/React.createElement("a", Object.assign({
    key: "privacyStatement",
    className: "display-inline-block padding-bottom-2",
    href: "/legal/privacy-statement"
  }, onClick && {
    onClick: event => {
      onClick(event, {
        type: 'additional',
        text: 'Privacy Statement'
      });
      return true;
    }
  }), "Privacy Statement"), _span3 || (_span3 = /*#__PURE__*/_jsx("span", {}, "dot", ". "))), /*#__PURE__*/_jsx("span", {
    className: "margin-left-0"
  }, void 0, /*#__PURE__*/React.createElement("a", Object.assign({
    key: "accessibilityStatement",
    className: "display-inline-block padding-bottom-4",
    href: "//www.autotrader.com/legal/accessibility-statement"
  }, onClick && {
    onClick: event => {
      onClick(event, {
        type: 'additional',
        text: 'Accessibility Statement'
      });
      return true;
    }
  }), "Accessibility Statement"), _span4 || (_span4 = /*#__PURE__*/_jsx("span", {}, "dot", "."))), /*#__PURE__*/_jsx("div", {
    "data-cmp": "txt-copyRight"
  }, void 0, "\xA9", new Date().getFullYear() + ' ', "Autotrader, Inc. All Rights Reserved. \"Autotrader\" is a registered trademark of TPI Holdings, Inc. used under exclusive license."));
}
export default FooterLegal;